import styled from 'styled-components';
import { Typography, Stack } from '@mui/material';
import { ReactComponent as EmptyGraphic } from '../../assets/sleepy-cloud.svg';
import { FlexColumn } from '../Flex';

const Wrapper = styled(FlexColumn)`
  align-items: center;
  gap: 4px;
`;

const Message = styled(Typography).attrs(() => ({
  component: 'span',
}))`
  white-space: pre-wrap;
  text-align: center;
  color: ${({ theme }) => theme.palette.common.gray2};
  font-size: 16px;
`;

const EmptyStateBoxLink = styled.a`
  color: ${({ theme }) => theme.palette.common.blue4};
`;

const EmptyStateBoxSubTitle = styled(Message)`
  text-decoration: underline;
`;

const EmptyStateBoxClickableText = styled(Message)`
  color: ${({ theme }) => theme.palette.common.blue4};
  text-decoration: underline;
  cursor: pointer;
`;

type Props = {
  title: string;
  children: React.ReactNode;
  graphic?: React.ReactNode;
};

const EmptyStateBox = ({
  title,
  children,
  graphic = <EmptyGraphic />,
}: Props) => (
  <Wrapper>
    <Stack sx={{ mb: '16px' }}>{graphic}</Stack>

    <Typography sx={{ fontSize: '16px', fontWeight: 'bold' }}>
      {title}
    </Typography>

    <Message>{children}</Message>
  </Wrapper>
);

EmptyStateBox.Link = EmptyStateBoxLink;
EmptyStateBox.SubTitle = EmptyStateBoxSubTitle;
EmptyStateBox.ClickableText = EmptyStateBoxClickableText;

export default EmptyStateBox;
